<template>
<v-card>
    <v-toolbar color="primary" dense>

        <v-toolbar-title class="white--text">
            Static Page
        </v-toolbar-title>

        <div class="mx-3" />

        <v-toolbar-items>
            <v-tabs v-model="active" background-color="primary" slider-color="white">
                <v-tab class="white--text" ripple>Content</v-tab>
                <v-tab class="white--text" ripple>SEO</v-tab>
            </v-tabs>
        </v-toolbar-items>

        <v-spacer />

        <v-toolbar-items>
            <v-btn icon left @click="emitExit()">
                <v-icon color="white">close</v-icon>
            </v-btn>
        </v-toolbar-items>

    </v-toolbar>

    <v-card-text class="mt-3">

        <v-row no-gutters>

            <v-col cols="8" v-if="active===0">
                <v-card flat class="mr-2">
                    <v-select v-model="item.platform.id" :items="platforms" item-value="id" item-text="name" filled label="Page Platform" clearable :menu-props="{transition:'scale-transition'}" />
                    <div v-for="(lang, index) in selected_languages" :key="index">
                        <v-autocomplete v-model="selected_languages[index]" filled label="Page Language" :items="languages" item-value="code" item-text="name" />
                        <v-text-field v-model="item.translations.title[lang]" filled label="Page Title" />
                        <v-text-field v-model="item.slug" filled label="Page Slug" />
                        <tip-tap v-model="item.translations.body[lang]" :ref="'body_'+lang" :key="'body_'+lang" />
                    </div>
                </v-card>
            </v-col>

            <v-col cols="8" v-if="active===1">
                <v-card flat class="mr-2">

                    <div v-for="(lang, index) in selected_languages" :key="index">

                        <v-autocomplete v-model="selected_languages[index]" :items="languages" item-value="code" item-text="name" label="Page Language" filled />

                        <v-text-field v-model="item.translations.url_slug[lang]" filled label="URL Slug" />

                        <v-divider class="mb-3" />
                        <div v-for="meta in item.translations.html_meta[lang]">
                            <div>
                                <v-text-field v-model="meta.name" filled label="HTML Meta Name" />
                                <div class="mx-1" />
                                <v-text-field v-model="meta.content" filled label="HTML Meta Content" />
                            </div>
                        </div>

                        <div>
                            <v-btn block @click="item.translations.html_meta[lang].push({name:'', content:''})">Add HTML Meta</v-btn>
                            <div class="mx-1 my-1" />
                            <v-btn block @click="item.translations.html_meta[lang].pop()">Remove HTML Meta</v-btn>
                        </div>

                    </div>
                </v-card>
            </v-col>

            <v-col cols="4">
                <v-card class="ml-2" height="100%">

                    <v-card-text>
                        <div v-for="(lang, index) in selected_languages" :key="index">

                            <div>
                                <span class="subheading">Google Preview</span>
                            </div>

                            <div class="pt-2">
                                <span style="font-family: arial,sans-serif; color: #1a0dab; font-size: 18px;" v-html="item.translations.title[lang.toLowerCase()]" />
                                <span style="font-family: arial,sans-serif; color: #006621; font-size: 14px;">https://memento-address.com/{{item.slug}}
                                    <v-icon small style="color: #006621;">arrow_drop_down</v-icon>
                                </span>
                                <span style="font-family: arial,sans-serif; color: #545454; font-size: small;">{{ item.translations.body[lang] ? item.translations.body[lang].substring(0, 300).replace(/(<([^>]+)>)/ig, ' ') + ' ...' : ''}}</span>
                            </div>

                            <v-divider class="my-3" />

                            <div>
                                <span class="subheading">Keywords</span>
                            </div>

                            <div class="py-2">
                                <div v-for="(keyword, index) in getKeywords(item.translations.body[lang])" :key="index">
                                    <span v-if="keyword.word" class="text-capitalize">{{keyword.word}}: <span class="font-weight-bold">{{keyword.count}}</span></span>
                                </div>
                            </div>

                            <v-divider class="my-3" />

                            <div>
                                <span class="subheading">Suggestions</span>
                            </div>

                            <div class="py-2">
                                <span>Paragraphs: <span class="font-weight-bold">{{getOccurrences('p', item.translations.body[lang])}}</span></span>
                                <span>Links: <span class="font-weight-bold">{{getOccurrences('a href', item.translations.body[lang], false)}}</span></span>
                                <span>Subheadings: <span class="font-weight-bold">{{getOccurrences('h2', item.translations.body[lang])}}</span></span>
                            </div>

                        </div>
                    </v-card-text>

                </v-card>
            </v-col>

        </v-row>

    </v-card-text>

    <v-card-actions class="pa-3">
        <v-btn color="red" dark @click="delete_dialog = true">Delete</v-btn>
        <v-spacer />
        <v-btn color="primary" text @click="emitExit()">Cancel</v-btn>
        <v-btn color="primary" :loading="loading_save" @click="saveItem()">Save</v-btn>
    </v-card-actions>

    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text>
                Are you sure you want to delete this static page?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" @click="destroy()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../utils/PropDefaults.js";
import TipTap from "../utils/TipTap.vue";

export default {

    components: {
        'tip-tap': TipTap,
    },

    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.static_page_item)
            }
        },
        selected_languages: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            loading_save: false,
            active: null,
            is_saving: false,
            delete_dialog: false,
            languages: [],
            platforms: [],
            edit: [],
            metas: this.item.metas || []
        }
    },

    watch: {

        item: {
            handler() {
                this.edit = [];
            }
        },

        selected_languages: {
            handler() {
                this.edit = [];
                let array = [];
                this.selected_languages.forEach(function () {
                    array.push(false);
                });
                this.edit = array;
            }
        }

    },

    mounted() {
        this.getPlatforms();
        this.getLanguages();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        getPlatforms() {
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/platforms';

            this.$axios.get(endpoint)
                .then(response => {
                    this.platforms = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.emitError('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        getLanguages() {
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/languages';

            this.$axios.get(endpoint)
                .then(response => {
                    this.languages = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.emitError('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        saveItem() {
            if(!this.item.slug) {
                this.error('Slug required');
                return
            }
            this.loading_save = true;

            let save_static_page = {
                id: this.item.id,
                slug: this.item.slug,
                platform_id: this.item.platform.id,
                translations: this.item.translations
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/pages';

            if(!save_static_page.id) {
                delete save_static_page.id;

                this.$axios.post(endpoint, save_static_page) // eslint-disable-next-line
                    .then(() => {
                        this.$emit('refresh');
                        this.success('Static page added.');
                        this.emitExit();
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                // call update or save endpoints
                this.$axios.put(endpoint + '/' + save_static_page.id, save_static_page) // eslint-disable-next-line
                    .then(() => {
                        this.$emit('refresh');
                        this.success('Static page updated.');
                        this.emitExit();
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });

            }

        },

        destroy() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/translations/pages';

            this.$axios.delete(endpoint + '/' + this.item.id) // eslint-disable-next-line
                .then(() => {
                    this.$emit('refresh');
                    this.success('Static page deleted.');
                    this.$emit('exit');
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.delete_dialog = false;
                });
        },

        getOccurrences(needle, haystack, tag = true) {

            if(!needle || !haystack) {
                return null;
            }

            if(tag) {
                tag = '<' + needle + '>';
            } else {
                tag = needle;
            }

            return ((haystack.split(tag) || [])
                .length - 1);
        },

        getKeywords(string) {

            if(!string) {
                return null;
            }

            let aggs = string.replace(/(<([^>]+)>)/ig, ' ')
                .split(' ')
                .reduce((tally, word) => {
                    tally[word] = (tally[word] || 0) + 1;
                    return tally;
                }, {});

            let sort = Object.keys(aggs)
                .sort((a, b) => {
                    return aggs[a] - aggs[b]
                })
                .reverse();

            let sorted_aggs = [];
            for(let i = 0; i < sort.length; i++) {
                sorted_aggs[i] = {
                    'word': sort[i],
                    'count': aggs[sort[i]]
                };
            }

            return sorted_aggs.slice(0, 11);
        },

        emitExit() {
            this.$emit('exit');
        },

    },

}
</script>
